import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { FAQS } from '../utils/constants';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 md:py-24 bg-gray-50 px-4" data-id="element-61">
      <div className="max-w-3xl mx-auto" data-id="element-62">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-stone-900 mb-12" data-id="element-63">
          Domande Frequenti
        </h2>

        <div className="space-y-4" data-id="element-64">
          {FAQS.map((faq, index) => <div key={index} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-65">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-66">
                <span className="font-bold text-stone-900 text-lg pr-4" data-id="element-67">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-68">
                  <ChevronDownIcon className="w-6 h-6 text-gray-500 flex-shrink-0" data-id="element-69" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-70">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-71">
                    <div className="px-6 pb-5 text-stone-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-72">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}